<template>
    <div class="contacts">
        <h2 class="contacts__title">
            Контакты
        </h2>
        <div
            v-for="(office, index) in offices"
            :key="index" 
            class="contacts__office-item">
            <div class="contacts__worktime">Мы работаем с {{ office.worktime.from }} до {{ office.worktime.to }}</div>
            <div class="contacts__phone">
                <a :href="'tel:' + phone_raw">{{ phone }}</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "block-contacts",
    data() {
        const {
            phone,
            phone_raw,
            offices
        } = this.CONSTANTS;

        return {
            phone,
            phone_raw,
            offices
        }
    }
}
</script>

<style lang="scss" scoped>
.contacts {
    margin-top: 90px;

    @media (max-width: 767px) {
        margin-top: 70px;
    }

    @media (max-width: 320px) {
        margin-top: 40px;
    }

    &__title {
        margin: 0;
        margin-bottom: 0px;

        font-size: 30px;
        color: white;
        text-transform: uppercase;
        font-weight: 500;

        @media (max-width: 767px) {
            color: black;
            padding-bottom: 0;
        }
    }

    &__office-item {
        font-size: 16px;
        font-weight: 500;
    }

    &__address {
        color: #fff;

        @media (max-width: 767px) {
            color: #000;
        }
    }

    &__worktime {
        font-size: 16px;
        color: white;
        padding-top: 10px;
        font-weight: 500;

        @media (max-width: 767px) {
            font-size: 16px;
            color: black;
            padding-top: 10px;
            font-weight: 500;
        }
    }

    &__phone {
        padding-top: 10px;

        a {
            font-size: 20px;
            color: #ed0000;
            font-weight: 700;    
        }
    }
}
</style>